import { SET_EMAIL_IS_VALID, SET_PHONE_IS_VALID } from './types';

type Action = { type: typeof SET_EMAIL_IS_VALID , payload: boolean, sourceField: string } | { type: typeof SET_PHONE_IS_VALID, payload: boolean, sourceField: string };

export function formReducer(state: any, action: Action) {
    switch (action.type) {
      case SET_EMAIL_IS_VALID:
        return { ...state, [action.sourceField]: action.payload }
      case SET_PHONE_IS_VALID:
        return {...state, [action.sourceField]: action.payload }
      default:
        return state
    }
  }